export default __webpack_public_path__ + "static/radioactive_w.c68ae23f1da52f6fe6fd5177c83059a9.svg";